import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/Buttons/Button";
import Translate from "../../../components/Translate";
import { useNotifications } from "../../../contexts/notificationContext";
import { useTranslations } from "../../../contexts/translationContext";
import DataService from "../../../services/data.service";

interface IProps {
    show: boolean
    onHide: (boolean) => void
    projectId: number
}

const DeleteProjectPopup: React.FC<IProps> = ({ show, onHide, projectId }) => {
    const [title, setTitle] = useState<string>();
    const { handleResult, handleException } = useNotifications();
    const { translate } = useTranslations();

    useEffect(() => {
        translate('Delete project').then(translated => setTitle(translated));
    }, [projectId]);

    function deleteProject() {
        DataService
            .delete('api/v1/Projects/', projectId)
            .then(response => {
                handleResult(response);
                if (response.isSuccesful === true) {
                    if (onHide)
                        onHide(true);
                }
            })
            .catch(e => handleException(e));
    }

    return (
        <Modal show={show} onHide={() => onHide(false)} size='lg'>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div><Translate>Are you sure you want to delete this project?</Translate></div>
            </Modal.Body>
            <Modal.Footer>
                <Button text='Delete' variant='danger' onClick={deleteProject} />
            </Modal.Footer>
        </Modal>
    );
}
export default DeleteProjectPopup;
